import Link from "next/link";
import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import { buyModalHide } from "../../redux/counterSlice";
import { Confirm_checkout } from "../metamask/Metamask";
import Image from "next/image";
import {
  createPledge,
  getAccountHoldersForUserId,
  getServerWalletForAccountHolder,
  getWalletBalances, mint
} from "../../utils/api";
import {getAccountHolderId, getUserId, isAdmin} from "../../utils/jwtUtil";
import Spinner from "../Spinner";
import {Alert} from "@mui/material";

const BuyModal = () => {
  const { buyModal, projectData } = useSelector((state) => state.counter);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [cadrsAmount, setCadrsAmount] = useState(1); // State for CADRs amount
  const dispatch = useDispatch();
  const [accountHolderId, setAccountHolderId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  
  const {data: serverWalletData, error: serverWalletError} = getServerWalletForAccountHolder(accountHolderId);

  useEffect(() => {
    if (!isAdmin()) return;
    
    if (projectData){
      setAccountHolderId(projectData.accountHolderId);
    }
  },[projectData]);


  async function handleSubmit(e) {
    e.preventDefault();
    setIsButtonDisabled(true);
    setIsLoading(true); // Show spinner
    try {
      const response = await mint({
        tokenId: projectData.tokenId,
        to: serverWalletData[0].walletAccountId,
        amount: Number(cadrsAmount), // Use the state variable here
      });

      if (response?.success.toString() === "true") {
        setTimeout(() => {
          window.location.href = "/activity";
        }, 3000); // Redirect after 3 seconds
      }
      else{
        console.warn("No mint performed");
      }

      setSuccessMessage("Mint successful!");
    } catch (error) {
      console.error("Error minting:", error);
    } finally {
      setIsButtonDisabled(false);
      setIsLoading(false); // Hide spinner
    }
  }

  if (!projectData) return;
  if (!serverWalletData || !Array.isArray(serverWalletData)) return;
  
  return (
    <div>
      {/* <!-- Buy Now Modal --> */}
      <div className={buyModal ? "modal fade show block" : "modal fade"}>
        <div className="modal-dialog max-w-2xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="buyNowModalLabel">
                Mint
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => dispatch(buyModalHide())}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="fill-jacarta-700 h-6 w-6 dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
                </svg>
              </button>
            </div>

            {/* <!-- Body --> */}
            <div className="modal-body p-6">
              <div className="mb-2 flex items-center justify-between">
                <span className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
                  Item
                </span>
              </div>

              <div
                  className="dark:border-jacarta-600 border-jacarta-100 relative flex items-center border-t border-b py-4">
                <figure className="mr-5 self-start">
                  <Image
                      width={150}
                      height={150}
                      src={`/images/projects/${projectData.projectId}.webp`}
                      alt="avatar 2"
                      className="rounded-2lg"
                      loading="lazy"
                  />
                </figure>

                <div>
                  <h3 className="font-display text-jacarta-700 mb-1 text-base font-semibold dark:text-white">
                    {projectData.projectName}
                  </h3>
                </div>
              </div>

              {/* <!-- Total --> */}
              <div
                  className="dark:border-jacarta-600 border-jacarta-100 relative mb-2 flex items-center overflow-hidden rounded-lg border">
                <div className="border-jacarta-100 bg-jacarta-50 flex flex-1 items-center self-stretch border-r px-2">
                <span className="font-display text-jacarta-700 text-sm">
                    CADRs
                  </span>
                </div>

                <input
                    type="number"
                    className="focus:ring-accent h-12 w-full flex-[3] border-0 focus:ring-inse dark:text-jacarta-700"
                    placeholder="Amount"
                    min={0}
                    value={cadrsAmount} // Bind the state to input
                    onChange={(e) => setCadrsAmount(e.target.value)}
                />
              </div>

            </div>
            {/* <!-- end body --> */}

            <div className="modal-footer">
              <div className="flex items-center justify-center space-x-4">
                { /*<Confirm_checkout projectData={projectData} cadrsAmount={cadrsAmount} accountHolderAddress={accountHolderAddress}/> */}
                <button
                    type="button"
                    onClick={handleSubmit}
                    disabled={isButtonDisabled}
                    className="bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                >
                  {isLoading ? (
                      <div className="flex items-center justify-center">
                        <Spinner/> {/* Display the spinner component */}
                        <span className="ml-2">In progress...</span>
                      </div>
                  ) : (
                      "Mint"
                  )}
                </button>
              </div>
            </div>

            {successMessage && (
                <Alert severity="success">
                  {successMessage}
                </Alert>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyModal;
